export default __webpack_public_path__ + "static/media/support.4ee110a4.svg";